import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { parseErrorDetail } from "../lib/api";

export default function MFAChallenge() {
  const { verifyMfa } = useAuth();
  const nav = useNavigate();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const r = await verifyMfa(code.trim());
      if (r.user?.role === "OWNER_ADMIN") nav("/admin", { replace: true });
      else nav("/portal", { replace: true });
    } catch (err) {
      setError(parseErrorDetail(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="apwo-auth-shell">
      <div className="apwo-auth-card" data-testid="mfa-card">
        <header className="apwo-auth-header">
          <p className="apwo-brand-eyebrow">AUTOPARTSB2B</p>
          <h1 className="apwo-auth-title">Two-factor code</h1>
          <p className="apwo-auth-sub">Enter the current 6-digit code from your authenticator app, or a one-time recovery code.</p>
        </header>
        <form className="apwo-auth-form" onSubmit={onSubmit} noValidate data-testid="mfa-form">
          <label className="apwo-field">
            <span>Code</span>
            <input
              type="text"
              inputMode="text"
              autoComplete="one-time-code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
              minLength={6}
              maxLength={12}
              data-testid="mfa-code"
              autoFocus
            />
          </label>
          {error && <div className="apwo-alert-error" role="alert" data-testid="mfa-error">{error}</div>}
          <button type="submit" className="apwo-btn-primary" disabled={submitting || !code} data-testid="mfa-submit">
            {submitting ? "Verifying…" : "Verify"}
          </button>
        </form>
        <footer className="apwo-auth-footer">
          <p className="apwo-fineprint">
            Lost your authenticator? Contact AUTOPARTSB2B on 0426 266 655 for admin-verified reset.
          </p>
        </footer>
      </div>
    </div>
  );
}
